import { useMutation, useQueryClient } from '@tanstack/react-query';
import { availabilityReportService } from '@/services';
import { queryKeys } from '@/services/query-keys';
import { AvailabilityReportListItem } from '@/types';
import { logger } from '@/utils/logger';

interface SendPayload {
  reportId: number;
}

type SendOptions = {
  onSuccess?: (data: AvailabilityReportListItem) => void;
  onError?: (error: Error) => void;
};

export const useSendAvailabilityReport = (options?: SendOptions) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ reportId }: SendPayload) =>
      availabilityReportService.sendReport(reportId),
    onSuccess: async (data, { reportId }) => {
      await queryClient.invalidateQueries({ queryKey: queryKeys.availabilityReport.detail(reportId) });
      await queryClient.invalidateQueries({ queryKey: queryKeys.availabilityReport.list() });
      options?.onSuccess?.(data);
    },
    onError: (error: Error) => {
      logger.error('Failed to send availability report:', error);
      options?.onError?.(error);
    },
  });
};
